import {
  sessionStoreSet,
  STORE_KEY_ACCOUNT,
  STORE_KEY_ACCOUNT_OPTIONS,
  STORE_KEY_AUTH,
  STORE_KEY_FEATURES,
  STORE_KEY_ID_LIST,
  STORE_KEY_LANG,
  STORE_KEY_LIST,
  STORE_KEY_LISTS_COUNT,
  STORE_KEY_LOGIN_TYPE,
  STORE_KEY_SECKEY,
  STORE_KEY_USER,
  STORE_KEY_USER_LANG,
  STORE_KEY_USER_LISTS,
  STORE_KEY_USER_OPTIONS,
  storeSet
} from 'mailup-react-helpers'

import {
  beAccountsApiGetAccountConfiguration,
  beAccountsApiGetAccountStatus,
  beAccountsApiGetOptions
} from 'Api/beAccountsApi'

import {
  beAccountSettingsApiGetSessionOauth2Token,
  beAccountSettingsApiGetUser
} from 'Api/beAccountSettingsApi'
import { beAsyncTrackingApiCheckTrackingDomainIsCustomizable } from 'Api/beAsyncTracking'
import { beFeatureToggleGetFlagsToShow } from 'Api/beFeaturetoggle'
import {
  BeListApiGetList,
  beListGetUserVisibleLists
} from 'Api/BeListApi'

import { beListApiGetListsLazy } from 'Api/beListApiTS'


import {
  APP_CLIENT_ID,
  LOGIN_TYPE_ADM,
  LOGIN_TYPE_ADMLIMITED,
  LOGIN_TYPE_RESELLER,
  OFFER_TYPE_LIGHT
} from 'Constants/index'

import PendoTracking from 'Helpers/pendoTracking'

import { initFeatures, initOptions } from 'Config/config'

const formatOption = optionId => {
  return `${optionId}`.padStart(3, '0')
}

const getOauthToken = async seckey => {
  const { token } = await beAccountSettingsApiGetSessionOauth2Token({
    seckey,
    client_id: APP_CLIENT_ID
  })

  sessionStoreSet(STORE_KEY_AUTH, token)
  sessionStoreSet(STORE_KEY_SECKEY, seckey)
}

export const initApp = async ({ seckey, idList, loginType, smtpPlusUsers }) => {
  await getOauthToken(seckey)

  const [
    resAccount,
    resAccountStatus,
    user,
    resList,
    listOfNlList,
    resFeatures,
    resOptions
  ] = await Promise.all([
    beAccountsApiGetAccountConfiguration(),
    beAccountsApiGetAccountStatus(),
    beAccountSettingsApiGetUser(0),
    BeListApiGetList(idList),
    beListApiGetListsLazy({
      force: true,
      pageSize: 1,
      pageNumber: 1,
      orderBy: 'Id',
      orderDescending: 'false'
    }),
    initFeatures.length > 0
      ? beFeatureToggleGetFlagsToShow(initFeatures)
      : { Features: [] },
    beAccountsApiGetOptions(initOptions),
    beAsyncTrackingApiCheckTrackingDomainIsCustomizable()
  ])

  if (resList === null) {
    throw new Error('list is null')
  }
  if (user === null) {
    throw new Error('user is null')
  }

  const account = {
    Id: resAccount.Id,
    Domain: resAccount.Domain,
    Language: resAccount.Language,
    Options: resAccount.Options,
    Version: resAccount.Version,
    DataRetention: resAccount.DataRetention,
    SendMethodType: resAccount.SendMethodType,
    Bandwidth: resAccount.Bandwidth,
    IsSendMethodTypeFrequency: resAccount.SendMethodType === 1,
    Vdir: resAccount.Dir,
    IdOffer: resAccount.IdOffer,
    IsTrial: !!resAccount.IsTrial,
    IsRetailer: !!resAccount.IsRetailer,
    IsDeveloper: !!resAccount.IsDeveloper,
    SmtpPlusOrFastEmailUsersPresent: smtpPlusUsers > 0,
    GracePeriod: resAccountStatus.GracePeriod,
    GracePeriodNote: resAccountStatus.GracePeriodNote,
    SuspendType: resAccountStatus.SuspendType,
    SuspendDate: resAccountStatus.SuspendDate,
    IsCustomer: !!resAccount.IsCustomer,
    Environment: resAccount.Environment,
    Suspended: resAccount.Suspended,
    IsOfferLight: resAccount.IdOffer === OFFER_TYPE_LIGHT
  }

  const lang = resAccount.Language.toLowerCase()

  storeSet(STORE_KEY_ACCOUNT, account)
  storeSet(STORE_KEY_USER, user)
  storeSet(STORE_KEY_LIST, resList)
  storeSet(STORE_KEY_ID_LIST, resList.IdList)
  storeSet(STORE_KEY_LISTS_COUNT, listOfNlList.TotalItems)

  const userListsResponse = await beListGetUserVisibleLists(user.Id)

  storeSet(STORE_KEY_USER_LISTS, userListsResponse.Items)

  storeSet(STORE_KEY_LANG, lang)
  storeSet(STORE_KEY_LOGIN_TYPE, loginType)

  const userLang =
    typeof user?.Lang === 'string' && user?.Lang.length > 0
      ? user?.Lang.toLowerCase()
      : lang

  storeSet(STORE_KEY_USER_LANG, userLang)

  const numericUserOptions = user.Options.split(',')
  const numericAccountOptions = account.Options.split(',')

  const userOptions = resOptions.Items.filter(o =>
    numericUserOptions.includes(formatOption(o.Id))
  ).map(o => o.ShortName)

  const accountOptions = resOptions.Items.filter(o =>
    numericAccountOptions.includes(formatOption(o.Id))
  ).map(o => o.ShortName)

  const features = resFeatures.Features.filter(o => o.Show).map(o => o.Name)

  storeSet(STORE_KEY_USER_OPTIONS, userOptions)
  storeSet(STORE_KEY_ACCOUNT_OPTIONS, accountOptions)
  storeSet(STORE_KEY_FEATURES, features)

  PendoTracking(
    //  visitor
    {
      id: user.Id
    },
    //  account
    {
      id: account.Id,
      isLoginFromAdm: [LOGIN_TYPE_ADM, LOGIN_TYPE_ADMLIMITED].includes(
        loginType
      ),
      isLoginReseller: loginType === LOGIN_TYPE_RESELLER
    }
  )

  return {
    lang,
    userLang
  }
}
